import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IConnectedApplicationType } from '../types/ConnectedApplicationType';
import { API_VERSION, DIRECT_TRUST_PATH } from './RestApiConstants';

function UpdateConnectedApplicationConfig(id: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: `${API_VERSION}`,
    httpMethod: 'PUT',
    endpoint: `${DIRECT_TRUST_PATH}/${id}`,
    serverWideRequest: false
  };
}

// Backend is the source of truth for when things are created, not us
export type UpdateConnectedApplicationType = Omit<IConnectedApplicationType, 'createdAt'>;
export interface UpdateConnectedApplicationParams {
  connectedApplication: UpdateConnectedApplicationType;
}

export interface UpdateConnectedApplicationResult {
  error?: unknown;
  connectedApplication?: IConnectedApplicationType;
}

export function callUpdateConnectedApplication(request: UpdateConnectedApplicationParams): Promise<UpdateConnectedApplicationResult> {
  return makeJsonRestApiRequest<UpdateConnectedApplicationParams, UpdateConnectedApplicationResult>({
    config: UpdateConnectedApplicationConfig(request.connectedApplication.clientId),
    request,
  });
}